/**
 * @title business-details.js: Sub-module for Account pages
 * @description This module is used to handle business details tasks
 * @dependency
 * Global var on jsp:
 * var isHousehold
 * var isAffiliateRelated
 */
define(['membershipHelper', 'accountDetails', 'applicationAffiliateForm'], function(membershipHelper, accountDetails, affForm) {
  let BusinessDetails = {
    /**
     * Basic initial function. Sets events, form focus and fires the
     * needed validation methods.
     * @return {void}
     */
    init: function() {
      // membershipData  from BusinessInformation.jsp
      accountDetails.membershipData = membershipData;
      this.validationRules();
      BusinessDetails.initBusinessInfo();
      this.businessAccountManagerFormHandler();
      // this.businessInfoFormHandler();
    },
    /**
     * Initialize business information form. Needs to be invoked uppon succesfull ajax modular call of the form submition.
     */
    initBusinessInfo: function() {
      membershipHelper.formWizBangs(BusinessDetails.getBusinessInfoForm());
      accountDetails.setState();
      if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED 
			&&$('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
    	  accountDetails.setCity();  
      }
      BusinessDetails.bindBusinessInfoEvents();
      BusinessDetails.maskBusinessPhone();
    },
    /**
     * Gets business information form
     * @return {Jquery form} form
     */
    getBusinessInfoForm: function() {
      return $('#business-information-update');
    },
    /**
     * The validation rules for the inputs on Business Details
     * "postalCode" overwritten from account-details.js because of specific State dropdown input field
     * "phone", "singleemail", "notEqual" from membership-helper.js
     * @return {void}
     */
    validationRules: function() {
      // This rule is not in membership-helper.js and had to overwrite account-details.js because of isUS flag
      $.validator.addMethod('postalCode', function(value, element) {
        return !COSTCO.CAddressForm.isUS() ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
      }, messages.ERR_ENTER_ZIPCODE);
      membershipHelper.addValidationMethods();
    },
    /**
     * Validates a single input if passed to function,
     * or ALL validate-able inputs validate_inputs object.
     * @param  {Function} callback The function to be called after successful validation.
     * @param  {string}   rule     OPTIONAL: The specific rule to validate if we're dealing with just one input
     * @param  {string}   $input   OPTIONAL: Input field for validation against rule provided
     * @return {void}
     */
    validateFields: function(callback, rule, $input) {
      let $form = BusinessDetails.getBusinessInfoForm();
      let validate_inputs = COSTCO.BusinessDetails.attachRulesToInputFields;
      let rules_config_obj = COSTCO.BusinessDetails.inputRules();
      COSTCO.Checkout._dynamic_validate({
        input: $input,
        rule: rule,
        form: $form,
        validate_inputs: validate_inputs,
        rules_config_obj: rules_config_obj,
        callback: callback,
      });
    },
    /**
     * Attaches rules to address input fields
     * @return {void}
     */
    attachRulesToInputFields: function() {
      $('#update-line1').rules('add', BusinessDetails.inputRules().addressLine1);
      $('#update-line2').rules('add', BusinessDetails.inputRules().addressLine2);
      $('#update-city').rules('add', BusinessDetails.inputRules().city);
      $('#update-state').rules('add', BusinessDetails.inputRules().stateDropDown_state);
      $('#update-zip').rules('add', BusinessDetails.inputRules().zipCode);
    },
    /**
     * Defines rules object for input fields/form validation
     * @return {void}
     */
    inputRules: function() {
      let rules = {};
      rules.email_rule = {
        required: true,
        singleemail: true,
        messages: {
          required: messages.ERR_REQUIRED_EMAIL,
          singleemail: messages.ERR_INVALID_EMAIL,
        },
      };
      rules.addressLine1 = {
        maxlength: 30,
        required: true,
        valid_address: true,
        messages: {
          maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
          required: messages.ERR_INVALID_STREET_REQUIRED,
          valid_address: messages.ERR_INVALID_ADDRESS,
        },
      };
      rules.addressLine2 = {
        maxlength: 30,
        valid_address: true,
        messages: {
          maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
          valid_address: messages.ERR_INVALID_ADDRESS,
        },
      };
      rules.zipCode = {
        required: true,
        postalCode: true,
        minlength: 5,
        messages: {
          required: messages.ERR_ENTER_ZIPCODE_NEW,
          postalCode: messages.ERR_ENTER_ZIPCODE,
          minlength: messages.ERR_VALID_ZIPCODE,
        },
      };
      rules.city = {
        required: true,
        valid_cityState: true,
        messages: {
          required: messages.ERR_INVALID_CITY_REQUIRED,
          valid_cityState: messages.ERR_INVALID_CITY_NAME,
        },
      };
      rules.stateDropDown_state = {
        required: true,
        notEqual: 'NO_STATE_TYPE_SELECTED',
        valid_cityState: true,
        messages: {
          required: messages.ERR_INVALID_STATE_NAME,
          notEqual: messages.ERR_INVALID_STATE_NAME,
          valid_cityState: messages.ERR_INVALID_STATE_NAME,
        },
      };
      rules.phoneNum = {
        phone: true,
        required: true,
        messages: {
          phone: messages.ERR_INVALID_PHONE_10_DIGIT,
          required: messages.ERR_INVALID_PHONE_10_DIGIT,
        },
      };
      return rules;
    },
    /**
     * Update the Capp json and refresh the page.
     * @param  {object} data The response data returned from the server
     * @return {void}
     */
    sucessHandler: function(data) {
      COSTCO.util.updateCappJson(data.caller);
      COSTCO.util.processCappLogic();
      // Refresh with parameter.
      window.location.href = COSTCO.util.makeUrl('/BusinessDetailsView', {
        infoUpdateSuccess: true,
      });
    },
    /**
     * Form handler for the Business Account Manager form.
     */
    businessAccountManagerFormHandler: function() {
      membershipHelper.addValidationMethods($('#business-account-manager-form'));
      $('#business-account-manager-form').validate({
        rules: {
          member_firstname: {
            required: true,
            firstNameValidation: true,
          },
          member_lastname: {
            required: true,
            lastNameValidation: true,
          },
          member_number: {
            required: true,
            notEqual: membershipData.caller.cardNumber.value,
          },
        },
        messages: {
          member_firstname: {
            required: messages.ERR_INVALID_FNAME_REQUIRED,
            firstNameValidation: messages.ERR_INVALID_FNAME, 
          },
          member_lastname: {
            required: messages.ERR_INVALID_LNAME_REQUIRED,
            lastNameValidation: messages.ERR_INVALID_LNAME,
          },
          member_number: {
            required: messages.ERR_INVALID_MEMBERSHIP_NO,
            notEqual: messages.ADMIN_MEMBER_SELF_BUSINESS,
          },
        },
        submitHandler: (form) => {
          $(form).find('[name=remove_member]').val('');
          BusinessDetails.addOrRemoveBusinessAccountManager.call(form, 'add');
        },
      });
    },
    /**
     * Adds or removes Business Account Manager.
     * @param {string} operation Expected 'add' or 'remove'.
     */
    addOrRemoveBusinessAccountManager: function(operation) {
      $(this).find('input[name=operation]').val(operation);
      COSTCO.util.notification.clearNotification();
      COSTCO.util.ajax({
        url: '/MemberAccountAdminCmd',
        type: 'POST',
        data: $(this).serializeArray().map((obj) => {
          obj.value = $.trim(obj.value);
          return obj;
        }),
      }).then(COSTCO.util.safe(function(response, textStatus, jqXHR) {
        let data = JSON.parse(response);
        if (!accountDetails.hasError(data)) {
          BusinessDetails.sucessHandler(data);
        }
      }), 'COSTCO.AccountDetails.accountManagerFormHandler').fail(accountDetails.failHandler);
    },
    /**
     * Add person within household
     */
    addPerson: function() {
      affForm.openAddPersonModal({
        isBusinessDetails: true,
      });
    },
    /**
     * Add household
     */
    addPersonWithinHousehold: function(membershipNumber) {
      let affiliate = membershipHelper.getAffiliateFromDataBeanByNumber(membershipData, membershipNumber);
      affForm.editPerson({
        affiliate: affiliate,
        action: 'update',
        addHousehold: true,
        isBusinessDetails: true,
      });
    },
    /**
     * Remove person within household
     */
    removePersonWithinHousehold: function(affiliateMembershipNumber) {
      let affiliate = membershipHelper.getAffByHouseholdNumber(membershipData, affiliateMembershipNumber);
      affiliate = {
        membershipNumber: affiliate.cardNumber.value,
        firstName: affiliate.firstName.value,
        lastName: affiliate.lastName.value,
        houseHold: {
          membershipNumber: affiliate.household.cardNumber.value,
          lastName: affiliate.household.lastName.value,
          firstName: affiliate.household.firstName.value,
        },
      };
      affForm.removePerson({
        affiliate: affiliate,
        isBusinessDetails: true,
        excludeData: true,
        action: 'remove-household',
      });
    },
    /**
     * Opens Remove Business Account Manager modal.
     * @param {string} membershipNumber Membership number.
     * @param {string} unformattedFullName Unformatted full name of the manager to be removed.
     */
    openRemoveBusinessAccountManagerModal: function(membershipNumber, unformattedFullName) {
      COSTCO.dialog.modalStack({
        title: messages.ACCOUNTADMIN_REMOVE_PERSON_TITLE,
        body: COSTCO.util.tmpl('remove_business_account_manager_modal_body_tmpl', {
          fullName: COSTCO.util.capitalize(unformattedFullName.toLowerCase()),
        }),
        primary: messages.ACCOUNTADMIN_REMOVE_BUTTON,
        secondary: messages.BUTTON_CANCEL,
        primary_event: () => {
          COSTCO.dialog.close();
          let form = $(this).parents('form');
          form.find('[name=remove_member]').val(membershipNumber);
          BusinessDetails.addOrRemoveBusinessAccountManager.call(form, 'remove');
        },
      });
    },
    /**
     * Shows fields needed to add Business Account Manager.
     */
    showAddBusinessAccountManagerFields: function() {
      $(this).addClass('hide');
      $(this.form).find('.add-business-account-manager-fields').removeClass('hide');
      $(this.form).find('#business-account-manager-first-name').focus();
    },
    /**
     * The method initializes the binding for business membership information form buttons
     */
    bindBusinessInfoEvents: function() {
      $('#update-business-address-btn').unbind('click').click(function() {
        BusinessDetails.validateFields(sendAddressData);

        function sendAddressData() {
          if (accountDetails.needsVerification(true)) {
            membershipHelper
              // Execute address verification on the primary information address.
              .verifyAddresses({
                form: BusinessDetails.getBusinessInfoForm().selector,
                primary: membershipHelper.businessInformationSelectors,
              })
              // Invoke the address verification modal
              .then((verifyResponse) => membershipHelper.invokeMultiAVS(verifyResponse, function(addresses) {
                let data = BusinessDetails.prepareBusinessAddressData(addresses);
                BusinessDetails.ajaxUpdateBusinessInformation(data);
              })).fail(accountDetails.failHandler);
          } else { // form is valid
            let data = BusinessDetails.prepareBusinessAddressData();
            BusinessDetails.ajaxUpdateBusinessInformation(data);
          }
        }
      });
      $('#update-business-phone-btn').unbind('click').click(function() {
        BusinessDetails.validateFields(sendPhoneData, 'phoneNum', $('#update-phone'));

        function sendPhoneData() {
          let data = BusinessDetails.prepareBusinessPhoneData();
          BusinessDetails.ajaxUpdateBusinessInformation(data);
        }
      });
      $('#update-business-email-btn').unbind('click').click(function(event) {
        BusinessDetails.validateFields(sendEmailData, 'email_rule', $('#update-membership-email'));

        function sendEmailData() {
          let data = BusinessDetails.prepareBusinessEmailData();
          BusinessDetails.ajaxUpdateBusinessInformation(data);
        }
      });
    },
    /**
     * Call backend using ajax modular to update business information data and corelated UI sectoin.
     * @param  {JSON Obj} data JSON object to be passed to backend service
     */
    ajaxUpdateBusinessInformation: function(data) {
      COSTCO.util.notification.clearNotification();
      COSTCO.Checkout.ajax_update_state({
        method: 'POST',
        url: '/AjaxMemberBusinessInformationUpdateCmd',
        data: data,
        dataType: 'json',
        ajax_update_post_done: function(data) {
          if (data.error.application.length > 0) {
        	  COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application]);
          } else if (data.payload.data.status === 'success') {
        	COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message]);
            accountDetails.membershipData = JSON.parse(data.payload.data.memberDataJson);
            membershipData = JSON.parse(data.payload.data.memberDataJson);
            BusinessDetails.initBusinessInfo();
          }
        },
      });
    },
    /**
     * Prepare JSON data obj with only business address data from the form. Other data info is get from membershipData JSON.
     *
     * @param  {Array of JSON objects} (Optional) avsAddresses array of JSON objects with AVS correted address
     * @return {JSON Obj} data JSON object to be passed to backend service
     */
    prepareBusinessAddressData: function(avsAddresses) {
      let form = BusinessDetails.getBusinessInfoForm();
      let data = BusinessDetails.getDefaultBusinessInfoObj();
      // Common data
      data.updateSection = 'address';
      data.MembershipCrmBusiness_urbanizationName = form.find('input[name="MembershipCrmBusiness_urbanizationName"]').val();
      if (avsAddresses && avsAddresses.length > 0) { // If AVS obj is passed get address details from it
        let addressObj = avsAddresses[0];
        data.MembershipCrmBusiness_addressLine1 = addressObj.line1;
        data.MembershipCrmBusiness_addressLine2 = addressObj.line2;
        data.MembershipCrmBusiness_city = addressObj.city;
        data.MembershipCrmBusiness_stateDropDown_country = addressObj.country;
        data.MembershipCrmBusiness_stateDropDown_state = addressObj.state;
        data.MembershipCrmBusiness_zipCode = addressObj.zip;
      } else { // Otherwise, get address data from form
        data.MembershipCrmBusiness_addressLine1 = form.find('input[name="MembershipCrmBusiness_addressLine1"]').val();
        data.MembershipCrmBusiness_addressLine2 = form.find('input[name="MembershipCrmBusiness_addressLine2"]').val();
        data.MembershipCrmBusiness_city = form.find('input[name="MembershipCrmBusiness_city"]').val();
        data.MembershipCrmBusiness_stateDropDown_country = form.find('input[name="MembershipCrmBusiness_stateDropDown_country"]').val();
        data.MembershipCrmBusiness_stateDropDown_state = form.find('#update-state').find(':selected').val();
        data.MembershipCrmBusiness_zipCode = form.find('input[name="MembershipCrmBusiness_zipCode"]').val();
      }
      return data;
    },
    /**
     * Prepare JSON data obj with onlu business phone data from form. Other data info is get from membershipData JSON.
     * @return {JSON Obj} data JSON object to be passed to backend service
     */
    prepareBusinessPhoneData: function() {
      let data = BusinessDetails.getDefaultBusinessInfoObj();
      data.updateSection = 'phone';
      data.MembershipCrmBusiness_phone = BusinessDetails.getBusinessInfoForm().find('input[name="MembershipCrmBusiness_phone"]').val();
      return data;
    },
    /**
     * Prepare JSON data obj with onlu business email data from form. Other data info is get from membershipData JSON.
     * @return {JSON Obj} data JSON object to be passed to backend service
     */
    prepareBusinessEmailData: function() {
      let data = BusinessDetails.getDefaultBusinessInfoObj();
      data.updateSection = 'email';
      data.MembershipCrmBusiness_email = BusinessDetails.getBusinessInfoForm().find('input[name="MembershipCrmBusiness_email"]').val();
      return data;
    },
    /**
     * Creates JSON business information data object from caller
     * @return {JSON} JSON business information data object
     */
    getDefaultBusinessInfoObj: function() {
      let c = membershipData.caller;
      let data = {};
      data.authToken = COSTCO.Checkout.getAuthToken();
      data.MembershipCrmBusiness_stateDropDown_country = c.businessInfo.country.value;
      data.MembershipCrmBusiness_urbanizationName = c.businessInfo.urbanizationName.value;
      data.MembershipCrmBusiness_addressLine1 = c.businessInfo.addressLine1.value;
      data.MembershipCrmBusiness_addressLine2 = c.businessInfo.addressLine2.value;
      data.MembershipCrmBusiness_city = c.businessInfo.city.value;
      data.MembershipCrmBusiness_stateDropDown_state = c.businessInfo.state.value;
      data.MembershipCrmBusiness_zipCode = c.businessInfo.zip.value;
      data.MembershipCrmBusiness_phone = c.businessInfo.homePhone.field1.value + c.businessInfo.homePhone.field2.value + c.businessInfo.homePhone.field3.value;
      data.MembershipCrmBusiness_email = c.businessInfo.email.value;
      return data;
    },
    /**
     * Mask business info phone number in form input field
     */
    maskBusinessPhone: function() {
      $('#update-phone').unmask().mask('000-000-0000');
    },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.BusinessDetails = BusinessDetails;
  return BusinessDetails;
});



// WEBPACK FOOTER //
// ./js/account/business-details.js